module.exports = __webpack_public_path__ + "static/media/add.540ddece.svg";